import { DimensionDefinition } from 'libs/end-to-end/src/types/databases/dimensions/dimension-definition';
import { FilterDefinitionWithValues } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { Phrases } from 'libs/end-to-end/src/phrases';
import { SELECTED_SECONDARY_BREAKDOWN_NO_SELECTION_VALUE } from 'libs/end-to-end/src/filters-v2/filter-utils';

export type GroupBySelectionForTableView = {
  value: string;
  displayName: string;
  dimensionDefinition: DimensionDefinition | null;
  filterDefinition: FilterDefinitionWithValues | null;
};

export const getAllowedGroupBySelectionsForTableView = ({
  allDimensions,
  secondaryFilterDefinitions,
  language,
  includeNoSelection,
}: {
  allDimensions: DimensionDefinition[];
  secondaryFilterDefinitions: FilterDefinitionWithValues[];
  language: Phrases;
  includeNoSelection: boolean;
}): GroupBySelectionForTableView[] => {
  const items: GroupBySelectionForTableView[] = [];

  if (includeNoSelection) {
    items.push({
      value: SELECTED_SECONDARY_BREAKDOWN_NO_SELECTION_VALUE,
      displayName: language.noSelection(),
      dimensionDefinition: null,
      filterDefinition: null,
    });
  }

  // Each of the dimensions is a group by option
  for (const dimension of allDimensions) {
    items.push({
      value: dimension.columnHeaderValue,
      displayName: language.dimensionDisplayName({
        definition: dimension,
      }),
      dimensionDefinition: dimension,
      filterDefinition: null,
    });
  }

  // Each of the secondary filters is a group by option
  for (const secondaryFilter of secondaryFilterDefinitions) {
    items.push({
      value: secondaryFilter.columnHeaderValue,
      displayName: language.filterDefinitionDisplayName({
        definition: secondaryFilter,
      }),
      dimensionDefinition: null,
      filterDefinition: secondaryFilter,
    });
  }

  return items;
};
